var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kaer-component-wrap",style:(_vm.computedStyle),attrs:{"id":_vm.props.anchor || ''},on:{"click":function($event){return _vm.$emit('handleClick')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }